import CardItem from './CardItem'
import { ExperienceH1 } from '../Experience/ExperienceElems'
import './Hobbies.css';

export default function Hobbies() {
  return (
    <div className='cards' id='hobbies'>
      <ExperienceH1 id="hobbiesH1">Check out some of my hobbies!</ExperienceH1>
      <div className='cards__container'>
        <div className='cards__wrapper'>
        <ul className='cards__items'>
            <CardItem
              src='images/wentworth-falls.jpg'
              text='From hunting down epic waterfalls...'
              label='Adventure'
            />
            <CardItem
              src='images/queenscliff.jpg'
              text='... to conquering large cliffs.'
              label='Adventure'
            />
          </ul>
          <ul className='cards__items'>
            <CardItem
              src='images/go-kart.jpg'
              text='Doing a practise run with the @Zenardi team at the KF1 Circuit in Singapore.'
              label='Go Karting'
            />
            <CardItem
              src='images/soccer.jpg'
              text='A shooting practise session at North Turamarra Park.'
              label='Soccer'
            />
            <CardItem
              src='images/bouldering-9-degrees.jpg'
              text='Bouldering at the 9-Degrees institution; this was quite the workout!'
              label='Bouldering'
            />
          </ul>
        </div>
      </div>
    </div>
  )
}
